module.exports = __webpack_public_path__ + "static/kevin.0b7ce4fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/kevin.jpg
// module id = ./assets/kevin.jpg
// module chunks = 168707334958949